import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var NotFoundOnColorSvg = function NotFoundOnColorSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 236 242"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFACC",
    d: "M0 0h236v242H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF7B2",
    d: "M86.088 31.912c6.435 0 11.652-5.22 11.652-11.66s-5.217-11.66-11.652-11.66-11.652 5.22-11.652 11.66 5.217 11.66 11.652 11.66"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFEC44",
    d: "M191.555 91.275v27.199h33.133l9.318 9.325V91.531s-41.233-.256-42.455-.26zM234.01 139.008v27.199h-33.132l-9.318 9.325v-36.268s41.939-.367 42.455-.26zM20.425 98.81H1.846V7.767h7.586l-.727 84.116h11.254z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.781 60.132v108.76l30.98-30.753 27.815 7.916 7.463-29.396 42.513 10.852v-41.83l40.703-25.55zm11.991 12.853c-4.311 0-4.303-6.689 0-6.689s4.303 6.689 0 6.689m11.953 0c-4.312 0-4.303-6.689 0-6.689s4.303 6.689 0 6.689m11.766 0c-4.311 0-4.303-6.689 0-6.689s4.303 6.689 0 6.689"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M116.033 183.806H27.744l30.946-29.793 27.417 8.415 7.87-29.861 42.894 11.131-.546-42.075 40.99-24.97V183.87h-8.547l-.33-2.991-52.346.148z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m18.94 60.132.846-.846h149.469l.45 1.562-40.306 25.301v41.362l-1.056.82-41.692-10.642-7.255 28.574-1.052.605-27.334-7.78-30.628 30.405-1.443-.601zm1.692.846V166.86l29.537-29.322.828-.213 26.973 7.677 7.249-28.551 1.03-.612 41.457 10.583v-40.74l.397-.717 38.212-23.987z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M140.082 79.218H20.234v-2h119.848z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149,
    cy: 214.5,
    r: 17.5,
    fill: "#FFF7B2"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m133.147 28.198.847-.846h23.896v1.692h-23.05v31.359h-1.693z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M27.19 69.57a4.633 4.633 0 1 1 9.266 0 4.633 4.633 0 0 1-9.266 0m4.633-2.94a2.94 2.94 0 1 0 0 5.881 2.94 2.94 0 0 0 0-5.88M39.037 69.57a4.633 4.633 0 1 1 9.266.001 4.633 4.633 0 0 1-9.266 0m4.633-2.94a2.94 2.94 0 1 0 0 5.881 2.94 2.94 0 0 0 0-5.88M55.517 64.938a4.633 4.633 0 1 0 0 9.266 4.633 4.633 0 0 0 0-9.266m-2.941 4.633a2.94 2.94 0 1 1 5.881 0 2.94 2.94 0 0 1-5.881 0",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.177 102.095.54 41.592-1.059.83-42.078-10.919-7.655 29.045-1.066.594-26.941-8.269-29.075 27.992h86.19v1.692h-56.64v40.59h56.902v1.692H58.546l-.846-.846v-41.436H27.744l-.587-1.456 30.946-29.793.835-.199 26.575 8.156 7.645-29.009 1.031-.603L136.01 142.6l-.531-40.966.406-.734 40.99-24.97 1.286.723v107.216l-.846.846h-8.547v-1.692h7.701V78.159zM211.464 27.352h-23.83v1.692h22.983V91.11h1.693V28.197zM212.31 117.882v21.42h-1.693v-21.42zM212.31 220.563v-54.315h-1.693v53.468h-34.55v1.693h35.397z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M176.841 95.05H148.76v-2h28.081z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M172.822 43.277c8.477 0 15.35-6.873 15.35-15.35s-6.873-15.349-15.35-15.349-15.35 6.872-15.35 15.35c0 8.476 6.872 15.348 15.35 15.348"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m172.088 34.932 7.189-13.2-1.486-.81-6.51 11.953-3.457-5.324-1.419.922 4.231 6.515z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M156.626 27.927c0-8.944 7.251-16.195 16.196-16.195s16.196 7.25 16.196 16.195-7.251 16.196-16.196 16.196-16.196-7.251-16.196-16.196m16.196-14.503c-8.01 0-14.504 6.494-14.504 14.503s6.494 14.503 14.504 14.503 14.504-6.493 14.504-14.503-6.494-14.503-14.504-14.503M191.341 91.254l.354-.85c.609.001 11.156.066 21.547.13l14.215.087 6.419.04-.005.846.005-.846.842.846v36.004l-1.445.598-9.01-9.009h-32.566l-.847-.846v-27zm1.202.846v25.308h32.071l.598.248 7.813 7.812v-33.12l-5.579-.034zM148.938 196.913c-9.674 0-17.517 7.842-17.517 17.515s7.843 17.515 17.517 17.515 17.516-7.841 17.516-17.515-7.842-17.515-17.516-17.515m-15.824 17.515c0-8.739 7.085-15.823 15.824-15.823q.174 0 .348.004l-2.458 15.974.836.975h17.058c-.579 8.211-7.425 14.693-15.784 14.693-8.739 0-15.824-7.084-15.824-15.823m15.891-2.867 1.974-12.826a15.7 15.7 0 0 1 6.354 2.278zm.337 2.304h15.41a15.8 15.8 0 0 0-6.033-11.876z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m114.933 180.878.846-.846h52.66l.846.846v6.054h5.982l.847.846v53.304l-.847.846h-52.659l-.846-.846v-53.304l.846-.846h44.984v-5.208h-50.966v51.611h5.106v1.693h-5.953l-.846-.846zm52.659 7.797v-.05h-44.138v51.611h50.967v-51.611h-5.136v.05zM234.051 137.805l.251.833h.42v27.001l-.846.846h-32.567l-9.01 9.009-1.444-.598v-36.004l.838-.846.008.846-.007-.744v-.073l-.001-.029 1.792-.016 4.727-.039c3.915-.033 9.139-.075 14.38-.114a6438 6438 0 0 1 14.477-.094c1.99-.009 3.661-.015 4.852-.015a166 166 0 0 1 1.814.011l.06.002.074.003h.003c.018.001.1.005.179.021m-41.504 35.048v-33.122l.952-.008 4.727-.04c3.914-.033 9.139-.075 14.379-.114s10.495-.074 14.472-.093a1025 1025 0 0 1 5.952-.013v25.33h-32.071l-.598.247zm41.253-33.378h-.011z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M87.904 60.123V44.195h2v15.928z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.858.846 8.705 0h80.199l.846.846v7.401c5.09 1.553 8.792 6.286 8.792 11.883a12.4 12.4 0 0 1-4.189 9.301v17.86l-1.357.675-6.66-5.04-7.114 5.055-1.336-.69v-17.86a12.4 12.4 0 0 1-4.189-9.301c0-6.86 5.562-12.421 12.423-12.421q.99 0 1.938.15V1.692H9.55v89.346h10.408v1.692H8.705l-.847-.846V8.614H2.692v89.35h17.733v1.692H1.846L1 98.81V7.768l.846-.846h6.012zm71.72 29.846v14.96l6.284-4.466 1.001.016 5.798 4.388V30.692a12.36 12.36 0 0 1-6.541 1.86c-2.4 0-4.642-.681-6.541-1.86M86.12 9.401c-5.926 0-10.73 4.803-10.73 10.729s4.804 10.73 10.73 10.73 10.73-4.804 10.73-10.73S92.046 9.4 86.12 9.4",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.08 21.336h44.63v-1.692H21.08zM65.71 34.874H21.08v-1.692h44.63zM21.08 48.413h44.63V46.72H21.08z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M93.507 29.222v18.07l-7.155-5.416-7.616 5.416v-18.07l4.142 1.392c2.103.706 4.384.706 6.487 0zM19.781 60.132v18.09h119.205l30.125-18.09zm12.012 12.81c-4.311 0-4.303-6.688 0-6.688s4.303 6.689 0 6.689m11.843-.105c-4.312 0-4.303-6.689 0-6.689s4.303 6.689 0 6.689m11.842.106c-4.311 0-4.303-6.69 0-6.69s4.303 6.69 0 6.69M149.966 94.05l26.875-16.517V94.05zM148.248 214.475l10.434-13.027s5.936 4.286 6.638 13.027h-17.076z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h236v242H0z"
  }))));
};
export var NotFoundOnColor = function NotFoundOnColor(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: NotFoundOnColorSvg
  }));
};